module.exports = __webpack_public_path__ + "media/evolve/assets/icons/atlas/add-9a36bd923c20368392dad333f1feab49.svg";